import React from "react";
import ExcoKabKot from "../../components/organism/ExcoKabKot";

const PageExcoKabKot = () => {
  return (
    <>
      <ExcoKabKot />
    </>
  );
};

export default PageExcoKabKot;
